import { Button } from 'component/Button/Button'
import { Space } from 'component/Space/Space'
import { Typo } from 'component/Typo'
import { client } from 'config/environment'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { opt } from 'store/opt'
import { Item } from 'type/Item'

interface Props {
  item: Item
}

export const ComboTextButton = observer(({ item }: Props) => {
  const { baga } = opt
  const demo = useDemo()
  const checked = client && comboCartStore.isItemInCart(item.item_id)
  const text = i18n(checked ? baga ? 'RemoveFromComboCart' : 'InComboCart' : baga ? 'AddToComboCart' : 'ToComboCart')

  const onClick = useLatestCallback(() => {
    comboCartStore.toggleItem(item)
  })

  if (!demo.canCombine(item)) return null

  return (
    <Button xl text wide invert={checked && !baga} action={onClick}>
      <Space gap={6}>
        {!baga && <Icon name="shopping_bag" size={16} />}
        <Typo line={16}>
          {text}
        </Typo>
      </Space>
    </Button>
  )
})
